export const images = {
    dummyProduct: "/images/dummyProduct.svg",
    Advertise: "/images/advertisement01.png",
    Advertise1: "/images/advertisement2.png",
    Ellipse1: "/images/Ellipse29.svg",
    Ellipse2: "/images/Ellipse28.svg",
    logo: "/images/logo2.svg",
    background: "/images/BackgroundImage.png",
    heroBanner: "/images/hero-banner.png",
    sampleinfographics: "/images/sampleinfographics.png"
}
export const carouselImages = {
    image1: "/images/carousel1.png",
    image2: "/images/carousel2.png",
    image3: "/images/carousel3.png",
    image4: "/images/carousel4.png",
    image5: "/images/carousel25.png",
    image6: "/images/carousel6.png",

}

export const icons = {
    target: "/icons/target.svg",
    operations: "/icons/operations.svg",
    bot: "/icons/bot.svg",
}